import { Button } from '../Button'
import { Icon } from '../Icon'
import { tm } from '../tm'
import type { Project } from '@captaincause/types'
import type { CSSProperties } from 'react'

interface ProjectQuoteProps {
  project: Project
  className?: string
  style?: CSSProperties
}

const emptyObject = {}
export function ProjectQuote({
  project,
  className = '',
  style = emptyObject,
}: ProjectQuoteProps) {
  if (!project.organization?.leader) return null

  const { leader } = project.organization

  if (!leader.name && !leader.quote) {
    return null
  }

  return (
    <div
      className={tm(
        'flex flex-col items-center space-y-4 rounded-xl bg-light-gray p-8 pt-6 text-center',
        className,
      )}
      style={style}
    >
      {leader.quote ? (
        <>
          <Icon icon="quote" />
          <div className="text-lg font-semibold md:w-[80%] md:text-xl">
            {leader.quote}
          </div>
        </>
      ) : null}
      {leader.avatar ? (
        <div className="h-12 min-h-[48px] w-12 min-w-[48px] rounded-full">
          <img
            src={leader.avatar}
            alt={`${project.organization.name} logo`}
            className="h-full w-full rounded-full object-cover"
            width={48}
            height={48}
          />
        </div>
      ) : null}
      {leader.name ? (
        <Button href={leader.linkedin_url} variant="raw">
          <div className="mb-1 flex items-center justify-center text-sm font-semibold">
            {leader.name}
            {leader.linkedin_url ? (
              <Icon
                icon="linkedin"
                size="medium"
                className="ml-2 rounded-sm bg-medium-gray p-1"
                fill="fill-dark-gray"
              />
            ) : null}
          </div>
          <div className="text-xs text-dark-gray">{leader.position}</div>
        </Button>
      ) : null}
    </div>
  )
}
